import React from 'react'
import { Result, Button } from 'antd'
import { logout } from '../../helpers/auth/useSession';

export default function Restricted() {
    return (
        <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page. Please use the mobile app."
            extra={<Button type="primary"
                onClick={async () => {
                    await logout();
                }}
            >Log Out</Button>}
        />
    )
}
